import { Link } from 'react-router-dom';
import classes from './ErrorPages.module.css';
import errorImage from '../../public/icons/errorIcons/error403.png';
import studioLogo from '../../public/icons/stu-logo.svg';

const UnauthorizedError = () => {
  return (
    <div className={classes.errorPageContainer}>
        <header className={classes.headerContainer}>
            <div className={classes.studioLogoContainer}>
                <Link to="/">
                    <img src={studioLogo} alt="Studio Logo" />
                </Link>
            </div>
        </header>
        <div className={classes.errorContainer}>
            <div className={classes.errorContent}>
                <h3>Fehlercode: 401</h3>
                <h1>Du bist nicht eingeloggt!</h1>
                <h4>Dieser Bereich ist nur für angemeldete Nutzer zugänglich.</h4>
                <div className={classes.errorButtonContainer}>
                    <Link to="/" className={`${classes.homeButton} regularLarge`}>
                        Zur Startseite
                    </Link>
                    <Link to="/kontakt" className={`${classes.helpButton} regularLarge`}>
                        Hilfe
                    </Link>
                </div>
            </div>
            <div className={classes.errorImageContainer}>
                <img src={errorImage} alt="401 Error" />
            </div>
        </div>
    </div>
  );
};

export default UnauthorizedError;